import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getRefundedTickets } from '../../../../../../services/customer/ticketServices';
import PurchasedTicketsList from '../purchasedTickets/components/PurchasedTicketsList';
import DefaultPagination from '../../../../components/paginations/defaultPagination/DefaultPagination';

function RefundedTickets() {
  const [tickets, setTickets] = useState({});

  const [searchParams] = useSearchParams();

  const returnGroupedTickets = (resTickets = []) => {
    const groupedTickets = {};
    resTickets?.forEach((ticket) => {
      const groupKey = `${ticket.statement.statement_id}_${ticket.ride_id}`;
      if (!groupedTickets[groupKey]) {
        groupedTickets[groupKey] = [];
      }
      groupedTickets[groupKey].push(ticket);
    });
    return groupedTickets;
  };

  const fetchTickets = async (page = 1) => {
    const res = await getRefundedTickets({ page });
    setTickets({
      data: returnGroupedTickets(res.data),
      meta: res.meta,
    });
  };

  useEffect(() => {
    fetchTickets();
  }, []);

  return (
    <div className="flex flex-col gap-[30px]">
      {searchParams.get('tab') === 'refunded-tickets' && (
      <>
        <PurchasedTicketsList
          tickets={tickets?.data || {}}
        />
        <DefaultPagination
          currentPage={
                    Number(tickets?.meta?.currentPage) || 1
                }
          totalItems={tickets?.meta?.totalItems || 0}
          pageSize={tickets?.meta?.itemsPerPage || 10}
          onChange={fetchTickets}
        />
      </>
      )}
    </div>
  );
}

export default RefundedTickets;
